import { className } from '../styles';

export default function Box({ name = 'element', component = 'div', classes = [], ml, mr, mt, mb, children, ...props }) {
	const Component = component;
	return (
		<Component
			className={[name, ...classes, ...(ml ? [`ml-${ml}`] : []), ...(mr ? [`mr-${mr}`] : [])]
				.map(_cls => className(_cls, ''))
				.join(' ')}
			{...props}
		>
			{children}
		</Component>
	);
}
